import api from "./apiSmartLogistics.js";

export default {
  GetViewUsersExtractions() {
    return api.get(
      "ViewUsersExtractionsUsersExtractions/GetViewUsersExtractions"
    );
  },

  GetViewUserExtraction(Id) {
    return api.get(
      "ViewUsersExtractionsUsersExtractions/GetViewUserExtraction/" + Id
    );
  },

  InsertViewUsersExtractions(usersExtractions) {
    return api.post(
      "ViewUsersExtractionsUsersExtractions/InsertViewUsersExtractions",
      usersExtractions
    );
  },

  UpdateViewUsersExtractions(usersExtractions) {
    return api.put(
      "ViewUsersExtractionsUsersExtractions/UpdateViewUsersExtractions",
      usersExtractions
    );
  },
  DeleteViewUsersExtractions(id) {
    return api.delete(
      "ViewUsersExtractionsUsersExtractions/DeleteViewUsersExtractions/" + id
    );
  }
};
